// extracted by mini-css-extract-plugin
module.exports = {"container":"PdfReportsNew_container__35cd_","search":"PdfReportsNew_search__1wE69"};